//This file provides the code for the main page of the recipes
//section.

import {createRecipe, loadRecipes} from './recipes-functions';
import {updateFilters} from './recipes-filters';
import {renderRecipes} from './recipes-views';
import {addFooter} from './footer';
import {addMenu} from './sliding-menu';
import {loadHeaderHTML} from './head-html-getter';
import {checkForIE} from './ie-browser-test';

//The recipes section is not supported by IE.  Therefore, calling
//this function will redirect the user if IE reaches this page.
checkForIE();

//Add the site footer to this page.
addFooter();

//Add the initially-hidden sliding menu to the page.
addMenu();

//Add the HTML to the page header.
loadHeaderHTML();

//Do initial data load.
loadRecipes();

//Show recipes to user.
renderRecipes();

//Add function for create recipe button.
document.querySelector('#create-recipe').addEventListener('click',
    (e) => {
    //Create new recipe.
    const id = createRecipe();

    //Redirect to edit page.
    location.assign(`./recipes-edit.html#${id}`); 
});

//Add function to filter based on text box input after search
//form is submitted.
document.querySelector('#search-form').addEventListener('submit', 
    (e) => {
    //Cancel form's default behavior.
    e.preventDefault();

    //Hide or show search result banner.
    const newSearchText = e.target.elements.searchText.value.trim();
    const actionBar = document.querySelector("#search-actions");
    const searchLabel = document.querySelector("#message-span");

    if (newSearchText) {
        searchLabel.textContent 
            = "Showing search results for "
            + `"${newSearchText.toLowerCase()}."`
        actionBar.style.display = 'block';
    } else {
        actionBar.style.display = 'none';
    }

    //Update display of recipes.
    updateFilters({
        searchText: newSearchText
    });
    renderRecipes();
});

//Add handler to button that clears searh text.
document.querySelector("#clear-search").addEventListener("click",
    () => {
    //Hide search result banner.
    const actionBar = document.querySelector("#search-actions");
    actionBar.style.display = 'none';

    //Clear search box.
    const searchBox = document.querySelector("#search-text"); 
    searchBox.value = '';

    //Update display of recipes.
    updateFilters({
        searchText: ''
    });
    renderRecipes();
});


//Add function for sorting dropdown.
document.querySelector('#filter-by').addEventListener('change', 
    (e) => {
    updateFilters({
        sortBy: e.target.value
    });
    renderRecipes();
});

//Add function to window to keep web pages consistant.
window.addEventListener('storage', (e) => {
    if (e.key === 'recipes') {
        //Reinitialize page; this will reset local storage.
        loadRecipes();

        //Update DOM.
        renderRecipes();
    }   
});